import { BugTrackerSection, useBugTracker } from "@/helpers/bugTracker";
import { useChooseDeviceStore } from "@/stores/chooseDevice/chooseDevice";
import { useHowYouRateDeviceStore } from "@/stores/howYouRateDevice/howYouRateDevice";
import { useTIWStore } from "@/stores/tiw/tiw";
// import { ref } from 'vue'

import { I_AXIOS } from "../requests/configRequest.model";
import it4GetStatusQuestion from "../requests/it4GetStatusQuestion/it4GetStatusQuestion";
import { useAnalyticsEventPreState } from "../useAnalytics/useAnalytics";
import useRegisterProduct from "../useRegisterProduct/useRegisterProduct";

export async function usePostQuestDevice() {
    const HowYouRateDeviceStore = useHowYouRateDeviceStore();
    const TIWStore = useTIWStore();
    const chooseDeviceStore = useChooseDeviceStore();

    await useRegisterProduct();

    if (Number.isNaN(Number.parseFloat(HowYouRateDeviceStore.registeringDeviceData?.price))) {
        chooseDeviceStore.setIsDeviceNotAccepted(true);

        return;
    }

    // Вопрос для экрана "В каком состоянии ваше устройство?"
    try {
        const StatusQuestionData = await it4GetStatusQuestion({
            deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
            token: TIWStore.WIDGET_DATA.token,
            lang: TIWStore.standardizedLocale,
            from: 3,
        });

        StatusQuestionData.options.forEach((el) => {
            el.imageVariant = `${I_AXIOS.IT4_HOST_PREVIEW}/attach/get2/${el.imgCid}`;
        });

        HowYouRateDeviceStore.questionData = StatusQuestionData;
    } catch (e) {
        useBugTracker("ChooseDevice - it4GetStatusQuestion", BugTrackerSection.ERROR, {
            exception: e.message,
            request: {
                deviceId: HowYouRateDeviceStore.registeringDeviceData.deviceId,
                token: TIWStore.WIDGET_DATA.token,
                lang: TIWStore.standardizedLocale,
                from: 3,
            },
        });

        return;
    }

    useAnalyticsEventPreState();
}
